const DialogTypes = require("../action-types/dialog");

const internals = {
    initial: () => ({
        isDownloadOpen: false,
        isTransactionDialogOpen: false,
        isWhatsIncludedDialogOpen: false
    })
};

module.exports = (state, action) => {
    state = state || internals.initial();

    const { type, payload } = action;

    switch (type) {
        case DialogTypes.DIALOG_TRANSACTION_OPEN:
            return {
                ...state,
                isTransactionDialogOpen: true
            };

        case DialogTypes.DIALOG_TRANSACTION_CLOSE:
            return {
                ...state,
                isTransactionDialogOpen: false
            };

        case DialogTypes.DIALOG_DOWNLOAD_OPEN:
            return {
                ...state,
                isDownloadOpen: true,
                downloadCroquisId: payload.croquisId
            };

        case DialogTypes.DIALOG_DOWNLOAD_CLOSE:
            return {
                ...state,
                isDownloadOpen: false,
                downloadCroquisId: null
            };
        case DialogTypes.DIALOG_INCLUDED_OPEN:
            return {
                ...state,
                isWhatsIncludedDialogOpen: true
            };

        case DialogTypes.DIALOG_INCLUDED_CLOSE:
            return {
                ...state,
                isWhatsIncludedDialogOpen: false
            };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/dialog.js